import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { DealPreviewStyled } from '../../DealPreviewStyled';
import { rem } from 'polished';

export const DealPreviewStyledOVGB = styled(DealPreviewStyled)`
    padding: ${rem(12)};

    .step-container {
        margin-bottom: ${rem(32)};
        z-index: 2;

        .icon {
            &.ok {
                background: ${({ theme }) => theme.colors.black};
                border: 3px solid ${({ theme }) => theme.colors.orange1};
            }

            &.none {
                background: ${({ theme }) => theme.colors.white};
                border: 1px solid ${({ theme }) => theme.colors.primaryDisabled};
            }
        }
    }

    .deal {
        background-color: ${({ theme }) => theme.colors.white};
        border: 1px solid ${({ theme }) => theme.colors.grey16};

        .deal-content {
            padding: 0;

            .buttons {
                &-box {
                    width: 100% !important;
                }

                .buttons-box {
                    width: 100%;
                    @media (min-width: ${breakpoints.sm}px) {
                        width: initial;
                    }
                }
            }
            .order-number {
                padding: ${rem(10)} ${rem(20)} ${rem(10)} ${rem(20)};
                background-color: ${({ theme }) => theme.colors.grey10};
                font-family: ${({ theme }) => theme.fonts.fontSecondary};

                div {
                    font-size: ${rem(14)};
                    margin: 0;
                }
            }
            .car-header {
                padding: ${rem(10)} ${rem(20)} ${rem(10)} ${rem(20)};
                flex-direction: column;

                @media (min-width: ${breakpoints.sm}px) {
                    flex-direction: row;
                }

                .price-and-date {
                    .price-container {
                        .price .currencyLabel {
                            padding-left: 0;
                            font-size: ${rem(24)};
                        }
                    }

                    .priceWrap {
                        padding: 0;
                        .priceWrap--container {
                            text-align: start;
                        }
                    }

                    .date {
                        text-align: left;
                        margin-right: ${rem(10)};
                        color: ${({ theme }) => theme.colors.grey1};
                        font-family: ${({ theme }) => theme.fonts.fontSecondary};
                        font-size: ${({ theme }) => theme.fontSizes.h5};
                        font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                        @media (min-width: ${breakpoints.sm}px) {
                            text-align: right;
                            padding-right: 0;
                            margin-right: 0;
                        }

                        &-clock-icon {
                            margin-right: ${rem(10)};
                        }
                    }
                }
                .carInfoHeader {
                    margin-bottom: ${rem(12)};

                    .title-engineInfo {
                        font-size: ${({ theme }) => theme.fontSizes.h5};
                        color: ${({ theme }) => theme.colors.grey1};
                        text-transform: uppercase;
                    }

                    .car-title {
                        font-family: ${({ theme }) => theme.fonts.fontBase};
                        font-size: ${({ theme }) => theme.fontSizes.h3};

                        .title-specPack {
                            font-weight: ${({ theme }) => theme.fontWeights.textRegular};
                        }
                    }
                }
            }

            .content {
                padding-bottom: 0;

                .car-preview {
                    padding-bottom: 0;
                }

                .deal-steps-flow {
                    .step-container {
                        .icon {
                            &.ok {
                                background: ${({ theme }) => theme.colors.black};
                                border: none;
                            }

                            &.none {
                                background: ${({ theme }) => theme.colors.white};
                                border: 1px solid ${({ theme }) => theme.colors.primaryDisabled};
                            }
                        }

                        .text {
                            color: ${({ theme }) => theme.colors.black};
                            font-family: ${({ theme }) => theme.fonts.fontSecondary};
                        }
                    }
                }
            }
            .view-more {
                background: ${({ theme }) => theme.colors.grey10};
                display: flex;
                justify-content: flex-start;
                align-items: center;

                @media (min-width: ${breakpoints.sm}px) {
                    width: ${rem(240)};
                    margin-left: auto;
                    background: ${({ theme }) => theme.colors.white};
                    padding-right: ${rem(20)};
                }
                .details-link {
                    padding: ${rem(20)};
                    text-decoration: underline;
                    text-transform: uppercase;
                    font-family: ${({ theme }) => theme.fonts.fontSecondary};
                    font-size: ${({ theme }) => theme.fontSizes.h5};
                    cursor: pointer;
                    border-bottom: none;
                    @media (min-width: ${breakpoints.sm}px) {
                        padding-left: 0;
                    }

                    &:hover {
                        transform: none;
                    }
                }
            }
        }
    }

    .priceWrap {
        background-color: ${({ theme }) => theme.colors.white};
        padding-bottom: 0;
    }

    .deal .deal-content__order-data {
        padding: ${rem(10)} ${rem(20)};
        font-size: ${rem(14)};
        background: ${({ theme }) => theme.colors.theWhiteStripes};

        @media (min-width: ${breakpoints.xs}px) {
            padding: ${rem(10)} ${rem(20)} ${rem(10)} ${rem(40)};
        }
    }
`;
